import SpecialOffersForm from '@app/SpecialOffers/Form'

const AttributesViewController = () => import('./Controller')
const GroupView = () => import('./AttributesGroupView')

export default function install(Vue) {
  Vue.component('AttributesViewController', AttributesViewController)
  Vue.component('GroupView', GroupView)
  Vue.component('SpecialOffersForm', SpecialOffersForm)
}
